var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCircleDownXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_14395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 7.99998C0.833252 4.04194 4.04188 0.833313 7.99992 0.833313C11.958 0.833313 15.1666 4.04194 15.1666 7.99998C15.1666 11.958 11.958 15.1666 7.99992 15.1666C4.04188 15.1666 0.833252 11.958 0.833252 7.99998ZM7.99992 1.83331C4.59416 1.83331 1.83325 4.59422 1.83325 7.99998C1.83325 11.4057 4.59416 14.1666 7.99992 14.1666C11.4057 14.1666 14.1666 11.4057 14.1666 7.99998C14.1666 4.59422 11.4057 1.83331 7.99992 1.83331Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 4.49998C8.27606 4.49998 8.49992 4.72384 8.49992 4.99998V11C8.49992 11.2761 8.27606 11.5 7.99992 11.5C7.72378 11.5 7.49992 11.2761 7.49992 11V4.99998C7.49992 4.72384 7.72378 4.49998 7.99992 4.49998Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64636 7.64643C4.84163 7.45116 5.15821 7.45116 5.35347 7.64643L7.99992 10.2929L10.6464 7.64643C10.8416 7.45116 11.1582 7.45116 11.3535 7.64643C11.5487 7.84169 11.5487 8.15827 11.3535 8.35353L8.35347 11.3535C8.15821 11.5488 7.84163 11.5488 7.64636 11.3535L4.64636 8.35353C4.4511 8.15827 4.4511 7.84169 4.64636 7.64643Z",
    fill: "#2D2943"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_14395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleDownXs);
export default __webpack_public_path__ + "static/media/arrow-circle-down-xs.e92ca8b3.svg";
export { ForwardRef as ReactComponent };